'use es6';

import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const RECIPIENTS_FETCH = createAsyncActionTypes('RECIPIENTS_FETCH');